import { useEffect } from "react";

const ContactUs: React.FC = () => {
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-white font-sans text-gray-800"
      style={{ fontFamily: "Gambetta" }}
    >
      {/* Hero Section */}
      <section
        className="relative flex min-h-[75vh] w-full items-center justify-center"
        style={{
          backgroundImage: "url('/assets/imgs/ContactUsBG.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="relative z-10 text-center text-white">
          <h1
            className="animate-fade-in text-4xl font-bold tracking-widest md:text-5xl"
            style={{ fontFamily: "HistoryPro" }}
          >
            Contact
          </h1>
        </div>
      </section>

      {/* Contact Details */}
      <section className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-6 py-12 lg:grid-cols-3 lg:px-0">
        <div className="flex items-start rounded-lg shadow-xl">
          <img
            src="/assets/imgs/sales.jpg"
            alt="Sales Enquiry"
            className="h-full w-40 object-cover"
          />
          <div className="flex-1 p-6">
            <h1 className="mb-4 text-lg font-semibold">Sales Enquiry</h1>
            <p>+91 9302921921</p>
            <p>+91 9303921921</p>
            {/* <p className="mt-2 break-words">
              <a
                href="mailto:info@centurygroup.co.in"
                className="text-blue-600 hover:underline"
              >
                info@centurygroup.co.in
              </a>
            </p> */}
            <p className="email-container mt-2">
              <a
                href="mailto:info@centurygroup.co.in"
                className="text-blue-600 hover:underline"
              >
                info@centurygroup.co.in
              </a>
            </p>
          </div>
        </div>
        <div className="flex items-start rounded-lg shadow-xl">
          <img
            src="/assets/imgs/job.jpg"
            alt="Job Enquiry"
            className="h-auto w-40"
          />
          <div className="flex-1 p-6">
            <h3 className="mb-4 text-lg font-semibold">Job Enquiry</h3>
            <p>+91 9303921921</p>
            {/* <p className="break-words">
              <a
                href="mailto:careers@centurygroup.co.in"
                className="text-blue-600 hover:underline"
              >
                careers@centurygroup.co.in
              </a>
            </p> */}
            <p className="email-container mt-2">
              <a
                href="mailto:careers@centurygroup.co.in"
                className="text-blue-600 hover:underline"
              >
                careers@centurygroup.co.in
              </a>
            </p>
          </div>
        </div>
        <div className="flex items-start rounded-lg shadow-xl">
          <img
            src="/assets/imgs/office.jpg"
            alt="Main Office"
            className="h-full w-40 object-cover"
          />
          <div className="flex-1 p-6">
            <h3 className="mb-4 text-lg font-semibold">Main Office</h3>
            <p>Karmeta, Nandni Ronsara,</p>
            <p>Jabalpur, Madhya Pradesh 482002</p>
            <a
              href="#"
              className="mt-2 inline-block text-blue-600 hover:underline"
            >
              Get directions
            </a>
          </div>
        </div>
      </section>

      <div className="relative mx-auto max-w-7xl px-6 pb-12 lg:px-0">
        <div className="relative h-0 w-full pb-[56.25%]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14666.773933479199!2d79.8959753!3d23.2178386!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981b033c2e3a805%3A0x92bc061dec4064c1!2snakshatranagar!5e0!3m2!1sen!2sin!4v1743762243184!5m2!1sen!2sin"
            className="absolute left-0 top-0 h-full w-full"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
